module.exports = "/call-frontend/img/撒点-红.21f123fb.png";